import { Table, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Content } from '@/core/components';

import { formatDecimal } from '@feature/utils';

import { IndicatorResult } from '../model/MinStdTypes';

interface MinStdIndicatorOverviewProps {
  result: IndicatorResult[];
}

export function MinStdIndicatorOverview(props: MinStdIndicatorOverviewProps) {
  const { result } = props;
  const { t } = useTranslation();

  return (
    <Content type="full">
      <Text
        fw="500"
        size="lg"
      >
        {t('minStd.indicator.indicator')}
      </Text>
      <Table
        bg="white"
        style={{ borderRadius: '12px' }}
        striped
        highlightOnHover
        withTableBorder
        withColumnBorders
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t('minStd.indicator.indicatorCode')}</Table.Th>
            <Table.Th>{t('minStd.indicator.title')}</Table.Th>
            <Table.Th>{t('minStd.indicator.legend')}</Table.Th>
            <Table.Th>{t('minStd.indicator.totalScore')}</Table.Th>
            <Table.Th>{t('minStd.indicator.noOfItems')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {result.map(({ indicator, totalScore, items }) => (
            <Table.Tr key={indicator.indicatorCode}>
              <Table.Td>
                <Link
                  to="/minimal-standards/report/gather/$indicatorCode"
                  params={{ indicatorCode: indicator.indicatorCode }}
                  search
                >
                  {indicator.formattedIndicatorCode}
                </Link>
              </Table.Td>
              <Table.Td>{indicator.title}</Table.Td>
              <Table.Td ta="right">{indicator.legend}</Table.Td>
              <Table.Td ta="right">{formatDecimal(totalScore)}</Table.Td>
              <Table.Td ta="right">{items.length}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Content>
  );
}
